// Set webchat configuration
/* eslint-disable */
const daktelaGuiConfig = { server: 'https://edwardinvest.daktela.com/', accessToken: '3077rrs9ns609766nrr531o968o7n314' }; // Create async script element
const daktelaScriptEl = document.createElement('script');
(function (attrs) {
  Object.keys(attrs).forEach(function (key) {
    daktelaScriptEl.setAttribute(key, attrs[key]);
  });
})({ src: daktelaGuiConfig.server + 'external/web/web.js', type: 'text/javascript', async: true, charset: 'utf-8' });
daktelaScriptEl.onload = function () {
  const daktelaWeb = new daktelaGui();
  daktelaWeb.init(daktelaGuiConfig);
};
document.getElementsByTagName('head')[0].appendChild(daktelaScriptEl);
/* eslint-enable */
